// Lib
import React from 'react';

// Utils
import { isDraggingLineEdge, isDraggingLineControlPoint } from '../dragLayerUtil';

// Types
import { LineDragLayerProps } from '../dragTypes';
import { DraggedLineEdgePreview } from './DraggedLineEdgePreview';
import { DraggedLineControlPointPreview } from './DraggedLineControlPointPreview';
import { DraggedConnectedElement } from './DraggedConnectedElement';

export const LineDragLayerElement = (props: LineDragLayerProps) => {
    const { itemType } = props;

    if (isDraggingLineEdge(itemType)) {
        return <DraggedLineEdgePreview {...props} />;
    }

    if (isDraggingLineControlPoint(itemType)) {
        return <DraggedLineControlPointPreview {...props} />;
    }

    return <DraggedConnectedElement {...props} />;
};
